<template>
    <div>
        <h2 class="table-title">Gains énergétiques</h2>
        <el-table
            :data="data"
        >
            <el-table-column
                prop="solution"
                label="Solution d'éfficacité énergétique"
                min-width="127"
                sortable
            ></el-table-column>
            <el-table-column
                prop="gains_kwh"
                label="Gains énergétique annuel"
                min-width="106"
                sortable
            >
                <template #default="scope">
                    <span>{{ scope.row.gains_kwh }} MWh</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="gains_percent"
                label="Gain"
                min-width="39"
                sortable
            >
                <template #default="scope">
                    <span>{{ scope.row.gains_percent }} %</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="gains_euros"
                label="Gain économique annuel"
                min-width="105"
                sortable
            >
                <template #default="scope">
                    <span>{{ scope.row.gains_euros }} €</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="costs"
                label="Coût solution matériel + installation"
                min-width="140"
                sortable
            >
                <template #default="scope">
                    <span>{{ scope.row.costs }} €</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="times_before_benefit"
                label="TRI"
                min-width="70"
                sortable
            ></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: 'GainsTable',
        props:{
            data:{
                type: Array,
                required: true,
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>









// WEBPACK FOOTER //
// src/components/partials/EnergeticGains/GainsTable.vue